import { render, staticRenderFns } from "./NotFoundView.vue?vue&type=template&id=069d410e&scoped=true&"
var script = {}
import style0 from "./NotFoundView.vue?vue&type=style&index=0&id=069d410e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069d410e",
  null
  
)

export default component.exports